import React from "react";

const SVG = ({
    style = {},
    fill = "#000",
    width = "10px",
    height = "17px",
    className = "",
    viewBox = "0 0 24 24"
}) => (
        <svg
            width={height}
            style={style}
            height={height}
            viewBox={`0 0 ${height} ${height}`}
            xmlns="http://www.w3.org/2000/svg"
            className={`svg-icon ${className || ""}`}
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill={fill}
                d="M16.0070801,30.347168 C16.2902832,30.347168 16.7009277,30.2197266 17.0690918,30.0356445 C25.2961426,25.9433594 28.1281738,23.5786133 28.1281738,18.5234375 L28.1281738,8.27148438 C28.1281738,6.23242188 27.4768066,5.36865234 25.6643066,4.61816406 C24.3049316,4.03759766 19.3205566,2.36669922 18.0461426,1.97021484 C17.4089355,1.77197266 16.630127,1.64453125 16.0070801,1.64453125 C15.369873,1.64453125 14.5910645,1.78613281 13.9538574,1.97021484 C12.6794434,2.35253906 7.69506836,4.05175781 6.33569336,4.61816406 C4.53735352,5.36865234 3.87182617,6.23242188 3.87182617,8.27148438 L3.87182617,18.5234375 C3.87182617,23.5786133 6.7746582,25.815918 14.9309082,30.0356445 C15.2990723,30.2338867 15.7097168,30.347168 16.0070801,30.347168 Z M14.7468262,22.4599609 C14.1804199,22.4599609 13.7131348,22.2050781 13.3024902,21.6953125 L9.57836914,17.2915039 C9.29516602,16.9516602 9.15356445,16.5976562 9.15356445,16.2294922 C9.15356445,15.4082031 9.8190918,14.7709961 10.6262207,14.7709961 C11.0935059,14.7709961 11.4475098,14.9692383 11.8015137,15.3798828 L14.7185059,18.934082 L20.3117676,10.0415039 C20.6657715,9.48925781 21.0905762,9.22021484 21.6003418,9.22021484 C22.3791504,9.22021484 23.1013184,9.78662109 23.1013184,10.59375 C23.1013184,10.9194336 22.9597168,11.2734375 22.7473145,11.5991211 L16.1486816,21.6669922 C15.822998,22.1767578 15.3132324,22.4599609 14.7468262,22.4599609 Z"
            />
        </svg>
    );

export default SVG;
